<template>
    <div class="bge" id="linq">
        <div class="zt_box">
            <div class="box_top">
            <p class="top_logo"><a href="/" class="top_a"><img src="../../assets/image/jiameng/logo.png" class="logjp"></a></p>
            <div class="top_fr" id="ta">
                <a href="#" class="top_a on">分销商招募<span></span></a>
                <a href="/" class="top_a">进入商城首页<span></span></a>
            </div>
            </div>
        </div>

        <div class="banner" id="zt_box">
            <img src="../../assets/image/jiameng/banner.jpg" width="100%" height="550">
            <div class="zt_wp">
            <p class="ba_t">找货源 上夜樱情趣</p>
            <p class="ba_note">国内最大的情趣用品批发平台，年销售额超过2亿!</p>
            <div class="ba_cire">
                <p class="ba_cire_q"><img src="../../assets/image/jiameng/icon1.png" width="84" height="84"><i class="quan_t">零加盟费</i></p>
                <p class="ba_cire_q ml36"><img src="../../assets/image/jiameng/icon2.png" width="84" height="84"><i class="quan_t">零风险</i></p>
                <p class="ba_cire_q ml36"><img src="../../assets/image/jiameng/icon3.png" width="84" height="84"><i class="quan_t">正品保障</i></p>
            </div>
            </div>
        </div>

        <div class="tsm">
            <div class="tsm_wap">
            <img src="../../assets/image/jiameng/tbg.jpg" width="1080" height="550">
            <div class="tsm_box">
                <p class="tsm_t">门店生意不理想？</p>
                <p class="tsm_note">您缺一个靠谱的供应商</p>
                <p class="tsm_sm">夜樱情趣已全渠道覆盖——</p>
                <p class="tsm_sm">独立商城、APP、天猫、京东、微信等 </p>
                <p class="tsm_sm"> 每款商品都经过销售检验</p>
                <p class="tsm_note mt40">好不好卖，我们用数据说话</p>
            </div>
            </div>
        </div>  

        <div class="zt_box">
            <div class="our_box">
            <ul class="our_ul">
                <li class="our_li">
                <img src="../../assets/image/jiameng/cc_01.png" width="130" height="130" class="our_jp">
                <p class="our_t">合作模式</p>
                <p class="our_note">本分销商城采用 <br>批发与一件代发两种模式</p>
                </li>
                <li class="our_li w3">
                <img src="../../assets/image/jiameng/cc_02.png" width="130" height="130" class="our_jp">
                <p class="our_t"><span class="our_t_fl">=</span> 商品批发<span class="our_t_fr">+</span></p>
                <p class="our_note">支持混批<br>具体可咨询售前客服</p>
                </li>
                <li class="our_li">
                <img src="../../assets/image/jiameng/cc_03.jpg" width="130" height="130" class="our_jp">
                <p class="our_t">一件代发</p>
                <p class="our_note">无需缴纳费用,支持图片包下载<br>每日发货2次,节假日正常发货</p>
                </li>
            </ul>
            </div>
        </div>
        
        <div class="m_box">
            <img src="../../assets/image/jiameng/mbg.jpg" width="100%" height="360">
            <div class="m_wap">
            <p class="m_t">拿货返利 <span class="tit_t">/Rebates</span></p>
            <ul class="m_ul">
                <li class="m_li" style="background-color:"><p class="m_li_p">月累计拿货满1万<span class="m_li_t">返利100元</span></p></li>
                <li class="m_li"><p class="m_li_p">月累计拿货满2万<span class="m_li_t">返利300元</span></p></li>
                <li class="m_li"><p class="m_li_p">月累计拿货满3万<span class="m_li_t">返利900元</span></p></li>
            </ul>
            </div>
        </div> 

        <div class="zt_box">
            <ul class="lr">
            <li class="lr_li  lrf1">
                <p class="lr_li_t">一手货源，利润空间大</p>
                <p class="lr_li_note lr50">夜樱情趣合作供应商200余家</p>
                <p class="lr_li_note lr10">所有商品保证正品</p>
                <p class="lr_li_note lr10">成本价有绝对优势</p>
                <p class="lr_li_note lr20">夜樱情趣合作供应商200余家</p>
            </li>
            <li class="lr_li  lrf2"><img src="../../assets/image/jiameng/li_01.jpg" width="588" height="400"></li>
            </ul>
            <ul class="lr lr50">
            <li class="lr_li  lrf2"><img src="../../assets/image/jiameng/li_02.jpg" width="588" height="400"></li>
            <li class="lr_li  lrf1">
                <p class="lr_li_t">产品拿回去不好卖怎么办？</p>
                <p class="lr_li_note lr50">我们提供无忧售后，30天内可换货</p>
                <p class="lr_li_note lr30">商品质量问题，随时可退换！</p>
                <p class="lr_li_note lr10">商品非质量问题，30天内可换货！</p>
            </li>
            </ul>
        </div>

        <div class="zt_box">
            <ul class="nnav">
                <li class="nnav_li" style="float:left;"><img src="../../assets/image/jiameng/n_01.jpg" width="360" height="300"></li>
                <li class="nnav_li" style="float:left;"><img src="../../assets/image/jiameng/n_02.jpg" width="360" height="300"></li>
                <li class="nnav_li"><img src="../../assets/image/jiameng/n_03.jpg" width="360" height="300"></li>
            </ul>
        </div>
        
        <div class="tsm ls">
            <div class="ls_box">
            <p class="ls_t">1800余款商品  150余个品牌</p>
            <p class="ls_note">各品牌授权 正规渠道正品</p>
            <ul class="ls_ul">
                <li class="ls_li"><p class="ls_p"><img src="../../assets/image/jiameng/p_01.jpg" width="182" height="120"></p></li>
                <li class="ls_li"><p class="ls_p"><img src="../../assets/image/jiameng/p_02.jpg" width="182" height="120"></p></li>
                <li class="ls_li"><p class="ls_p"><img src="../../assets/image/jiameng/p_03.jpg" width="182" height="120"></p></li>
                <li class="ls_li"><p class="ls_p"><img src="../../assets/image/jiameng/p_04.jpg" width="182" height="120"></p></li>
                <li class="ls_li"><p class="ls_p"><img src="../../assets/image/jiameng/p_05.jpg" width="182" height="120"></p></li>
                <li class="ls_li"><p class="ls_p"><img src="../../assets/image/jiameng/p_06.jpg" width="182" height="120"></p></li>
                <li class="ls_li"><p class="ls_p"><img src="../../assets/image/jiameng/p_07.jpg" width="182" height="120"></p></li>
                <li class="ls_li"><p class="ls_p"><img src="../../assets/image/jiameng/p_08.jpg" width="182" height="120"></p></li>
                <li class="ls_li"><p class="ls_p"><img src="../../assets/image/jiameng/p_09.jpg" width="182" height="120"></p></li>
                <li class="ls_li"><p class="ls_p"><img src="../../assets/image/jiameng/p_10.jpg" width="182" height="120"></p></li>   
            </ul>
            </div>

        </div>

        <div class="zt_box">
            <div class="zt_tit">
            <p class="zt_tit_t">我们的优势 <span class="tit_t">/ Our Advantages</span></p>
            </div>
            <div class="our_pic">
            <ul class="pic_ul" id="pic_ul">
                <li class="pic_li">
                <div class="pic_box">
                    <img src="../../assets/image/jiameng/m1.jpg" width="340" height="280">
                    <div class="mask">
                    <p class="mask_t mt50">货源保障</p>
                    <p class="mask_note mt20">一手货源 正品保证</p>
                    </div>
                </div>
                </li>
                <li class="pic_li">
                <div class="pic_box">
                    <img src="../../assets/image/jiameng/m2.jpg" width="340" height="280">
                    <div class="mask">
                    <p class="mask_t mt50">商品丰富</p>
                    <p class="mask_note mt20">1800余款商品  150余个品牌</p>
                    </div>
                </div>
                </li>
                <li class="pic_li">
                <div class="pic_box">
                    <img src="../../assets/image/jiameng/m3.jpg" width="340" height="280">
                    <div class="mask">
                    <p class="mask_t mt50">自有品牌</p>
                    <p class="mask_note mt20">拥有COC与雅迪克  独家货源</p>
                    </div>
                </div>
                </li>
                <li class="pic_li">
                <div class="pic_box">
                    <img src="../../assets/image/jiameng/m4.jpg" width="340" height="280">
                    <div class="mask">
                    <p class="mask_t mt50">无忧售后</p>
                    <p class="mask_note mt20">批发30天换货  代发7天退换</p>
                    </div>
                </div>
                </li>
                <li class="pic_li">
                <div class="pic_box">
                    <img src="../../assets/image/jiameng/m5.jpg" width="340" height="280">
                    <div class="mask">
                    <p class="mask_t mt50">全国仓储</p>
                    <p class="mask_note mt20">全国7个仓库 最快可一日送达</p>
                    </div>
                </div>
                </li>
                <li class="pic_li">
                <div class="pic_box">
                    <img src="../../assets/image/jiameng/m6.jpg" width="340" height="280">
                    <div class="mask">
                    <p class="mask_t mt50">闪电发货</p>
                    <p class="mask_note mt20">10点与16点 每日准时发货2次</p>
                    </div>
                </div>
                </li>
            </ul>
            </div>

        </div>

        <!-- 轮播图 -->
        <div class="slider_box">
            <div class="zt_tit">
            <p class="zt_tit_t ff">关于夜樱情趣 <span class="tit_t">/ Our Advantages</span></p>
            </div>
            <div class="slider">
                <carousel></carousel>
            </div>
        </div>
        <div class="chose">
            <div class="zt_box">
                <p class="chose_t">为什么选择我们</p>
                <p class="chose_note">夜樱情趣致力于成为情趣用品行业的领导者。倡导"百变情趣•乐享生活"，精选全球精品，
                    携众多知名品牌共同打造最好的情趣用品网 。现已经拥有注册会员4300多万人，日访问
                    量达到500多万PV。公司成立于2009年，位于重庆市渝中区办公环境4500平米，在职员
                    工280余人，年销售额已突破2个亿。
                </p>
                <p class="chose_num"> 仓储面积4000平米，商品库存1500万</p>
                <p class="chose_num"> 全国共有7个仓库（重庆、西安、武汉、广州、北京、大连、江苏）</p>
                <p class="chose_num"> 在2014年已是B2C渠道最大商城，重庆市电子商务示范企业</p>
                <p class="chose_num"> 经营渠道覆盖独立B2C、第三方平台、APP、自媒体等</p>
                <div class="chose_pic">
                <p><img src="../../assets/image/jiameng/img7.jpg" width="340" height="200"></p>
                <p class="mt20"><img src="../../assets/image/jiameng/img8.jpg" width="340" height="200"></p>
                </div>
                <p class="chose_t">相关报道</p>
                <ul class="chose_ul" id="chose_ul">
                <li class="chose_li" data-id="1">
                    <a class="chose_a mr5">
                    <img src="../../assets/image/jiameng/img9.jpg" width="340" height="241px">
                    <p class="li_t">36氪专访夜樱情趣创始人王伟民</p>
                    <p class="li_note">Friday,29 January</p>
                    </a>
                </li>
                <li class="chose_li" data-id="2">
                    <a class="chose_a m5">
                    <img src="../../assets/image/jiameng/img10.jpg" width="340" height="241px">
                    <p class="li_t">商界网报道-创业十余载的情趣生意</p>
                    <p class="li_note">Friday,11 December</p>
                    </a>
                </li>
                <li class="chose_li" data-id="3">
                    <a class="chose_a ml5">
                    <img src="../../assets/image/jiameng/img11.jpg" width="340" height="241px">
                    <p class="li_t">解放碑大屏惊现不可描述的夜樱情趣礼物</p>
                    <p class="li_note">Friday,17 August</p>
                </a>
                </li>
                </ul>
            </div>
        </div>
        <div class="new_up" id="new_up">
            <div class="new">
            <a href="javascript:;" class="new_clo" id="new_clo"></a>
            <img src="../../assets/image/jiameng/new_01.jpg" width="1128" height="889" id="chose_pic">
            </div>
        </div>

        <div class="zt_box mt40">
            <div class="zt_tit hz">
            <p class="zt_tit_t">合作答疑 <span class="tit_t">/ Q&A</span></p>
            </div>
            <div class="toge">
            <p class="toge_q"><span class="q_q">问</span> 我是第一次与贵平台合作，我需要缴纳费用吗？</p>
            <p class="toge_q qa"><span class="q_q qaa">答</span>我们不会以任何形式收取加盟费与服务费，初次合作，可直接联系客服对接专员：QQ:3002719429 微信:<span class="wx_code_handle">xichungui188</span></p>
            <p class="toge_q"><span class="q_q">问</span> 贵平台所有的产品保证正品吗？</p>
            <p class="toge_q qa"><span class="q_q qaa">答</span>我们保证所有产品均为正品，可提供产品相关资质与品牌授权；我们在此行深耕10余年，与大部分供应商已建立战略合作 关系，我们保证所</p>
            <p class="toge_q"><span class="q_q">问</span> 平台有会员等级吗？</p>
            <p class="toge_q qa "><span class="q_q qaa">答</span>平台的会员等级分为三级，不同等级，价格不同，进货量（按累计）越大，等级越高，价格越优惠；具体可咨询售前客服</p>
            <p class="toge_q"><span class="q_q">问</span> 产品拿回去不好卖，怎么办？</p>
            <p class="toge_q qa aa"><span class="q_q qaa">答</span>针对需要退换货的商品，我们提供批发30天换货，代发7天退换政策</p>
            </div>
        </div>
        <!-- bot -->
        <div class="bot">
            <div class="zt_box">
                <div class="bot_fl">
                <p class="bot_t">关于夜樱情趣</p>
                <p class="bot_note">广东省广州市白云区</p>
                <p class="bot_note">TEL 023-62805799  </p>
                <p class="bot_note">vip@hongju.cc </p>
                </div>
                <div class="bot_fl">
                <p class="bot_t">分销请联系</p>
                <p class="bot_note">QQ 2328546960</p>
                <p class="bot_note">TEL <span class="mobile_handle">17347762059</span> </p>
                <p class="bot_note">微信 <span class="wx_code_handle">xichungui188</span>  </p>
                </div>
                <div class="bot_fl code">
                <p class="code"><img class="wx_img_handle" src="../../assets/image/jiameng/1600958630547008160.jpg" width="111" height="111"><span class="code_sp">微信扫码咨询</span></p> 
                </div>
            </div>
        </div>
        <div class="bott">
            Copyright © 2010-2015 Hongju All Rights Reserved 渝ICP备14000671号
        </div>
        <!-- 右侧小能客服 -->
        <div class="neng">
            <a href="javascript:;" onclick="kefun()"><img src="../../assets/image/jiameng/kff.png" width="300" height="200"></a>
        </div>
        <!-- 浮动导航 -->
        <div class="fix_box" id="zt_fix">
            <div class="fix">
            <p class="fix_t">欢迎电话联系</p>
            <p class="fix_tel mobile_handle">173 47762 059</p> 
            <p class="fix_zx">QQ在线咨询</p>
            <a href="javascript:;" class="fix_qq">点我咨询</a>
            <p class="fix_co">微信扫码咨询</p>
            <p class="qrjp"><img class="wx_img_handle" src="../../assets/image/jiameng/1600958630547008160.jpg" width="111" height="111"></p>
            </div>
        </div>
    </div>
</template>

<script>
import Carousel from "@/components/common/carousel"
export default {
    components:{
        'carousel': Carousel
    },
}
</script>

<style scoped>
@import url('../../assets/css/zt.css');
body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,a, fieldset,legend,input,textarea,p,blockquote,th,td{margin:0;padding:0;list-style: none;font-family: "Microsoft YaHei",Arial}
body{position: relative;}
img{border: 0;vertical-align: top;}
a:hover{text-decoration: none;}
.zt_box{width: 1080px;margin: 0 auto;position: relative;}
.box_top{height: 110px;line-height: 110px;overflow:hidden;}
.top_logo{margin-top: 40px;float: left;}
.logjp{width: 170px;height: 27px}
.top_fr{float: right;overflow:hidden;}
.top_a{display: block; height: 80px;line-height: 80px;color: #999;font-size: 16px;float: left;margin-left: 52px;margin-top: 10px;position: relative;}
.top_a.on{color: #666;}
.top_a.on span{display: block; background: url(../../assets/image/jiameng/underline.png) 50% 50% no-repeat; background-size: 58px 13px;width: 58px ;height: 13px; position:absolute;left: 50%;margin-left: -29.5px;bottom: 5px}
.banner{height: 550px;position: relative;}
.zt_wp{position: absolute;left: 50%;width: 1080px;height: 550px;margin-left: -540px;top: 0;overflow: hidden;}
.ba_t,.ba_note{color: #fff;text-align: right;}
.ba_t{font-size: 46px;font-weight: bold;margin-top: 150px; height: 50px;line-height: 50px;}
.ba_note{font-size:22px; margin-top: 25px;opacity: 0.6}
.ba_cire{overflow:hidden;margin-top: 54px;color: #fff;float: right;opacity: 0.6}
.ba_cire_q{float: left;}
.ml36{margin-left: 36px;}
.quan_t{display: block;font-size: 20px;font-style: normal;height: 30px;line-height: 30px;margin-top: 17px;text-align: center;}
.our_box{padding:35px 20px;}
.our_pic{margin-bottom: 60px;}
.our_jp{margin-top: 20px;}
.our_ul{overflow:hidden;}
.our_li{width:280px;text-align: center;float: left;}
.w3{width: 480px;}
.our_t{color: #333;margin-top: 60px; font-size: 28px;position: relative;}
.our_note{color: #999;font-size: 18px;margin-top: 28px;margin-bottom: 76px;line-height: 30px;}
.our_t_fl{position: absolute;top: 0;left: 20px}
.our_t_fr{position: absolute;top: 0;right:20px}
.zt_tit{width: 100%;text-align: center;margin-top: 30px;margin-bottom: 65px;}
.zt_tit_t{color: #333;font-size: 26px;height: 30;line-height: 30px;}
.tit_t{color: #cd0000;font-size: 20px;}
.pic_ul{overflow: hidden;}
.pic_li{float: left;}
.pic_box{position: relative;margin: 10px;width: 340px;height: 280px;}
.mask{position: absolute;top: 0;left: 0;width: 340px;height: 280px;background: rgba(0,0,0,0.1);}
.mask_t,.mask_note{color: #fff;height: 30px;line-height: 30px;text-align: center;}
.mask_t{font-size: 28px;font-weight: bold;}
.mask_note{font-size: 20px;}
.mt50{margin-top: 100px;}
.mt20{margin-top: 20px;}
.mt40{margin-top: 40px;margin-bottom: 120px;}
.ff{color: #fff;height: 40px;line-height: 40px;padding-top: 40px;}
/**/
.slider_box{width: 100%;margin-top: 30px;background-color: #2e343d;}
.slider{width: 1080px;margin: 0 auto;position: relative;}
.slider_fl{position: absolute;top: 35%;background: url(../../assets/image/jiameng/prev.png) 50% 50% no-repeat; background-size: 24px 45px;width: 25px;height: 50px;}
.fl{left: 0}
.fr{right: 0;background: url(../../assets/image/jiameng/next.png) 50% 50% no-repeat; background-size: 24px 45px;}
.slider_ul{height: 450px;}
.slider_li{width: 520px;height: 360px;transition: all 0.5s;cursor: default;-moz-transition: all 0.5s;cursor: default;
-webkit-transition: all 0.5s;cursor: default;-o-transition: all 0.5s;cursor: default;}
/**/
.tsm{background-color: #f5f5f5;height: 550px}
.tsm_wap{width: 1080px;margin: 0 auto;position: relative;}
.tsm_box{width: 347px;height: 275px;position: absolute;top: 127px;left: 127px;}
.tsm_t,.tsm_note,.tsm_sm{color: #333}
.tsm_t{font-size: 22px;height: 25px;line-height: 25px;}
.tsm_note{ font-size: 28px;font-weight: bold;margin-top: 10px;margin-bottom: 40px;height: 30px;line-height: 30px}
.tsm_sm{ color: #666;font-size: 20px;height: 30px;line-height: 30px }
.mt40{margin-top: 40px}
.m_box{height: 360px;position:relative;}
.m_wap{width: 1080px;position: absolute;left: 50%;top: 0;margin-left: -540px;}
.m_t{margin-top: 80px; color: #333;font-size: 24px;text-align: right;}
.m_ul{overflow: hidden;margin-top: 67px}
.m_li{background:#ffffff;float: right;width: 206px;height: 90px;border-radius: 5px;border: 1px solid #ccc;margin: 0 10px; color: #333;font-size: 18px;text-align: center;}
.m_li_p{width: 140px;height: 60px; line-height: 30px;text-align: center;margin: 15px auto;}
.m_li_t{ color: #cd0000;font-weight: bold; }

.lr{margin-top: 100px;overflow: hidden;}
.lr_li{float: left;height: 400px;}
.lrf1{width: 492px;background-color: #2e343d}
.lrf2{width: 588px}
.lr_li_t{ color: #ffd200;font-size: 30px;margin-top: 70px;font-weight: bold;text-align: center;}
.lr_li_note{ color: #fff;font-size: 20px;text-align: center; height: 30px;line-height: 30px;}
.lr50{margin-top: 50px;}
.lr20{margin-top: 20px;}
.lr30{margin-top: 30px;}
.lr10{margin-top: 10px;}

.nnav{overflow: hidden;margin-top:120px;width: 100%}
.nnav_li{float: left;}
.ls{height: 600px;}
.ls_box{width: 1080px;margin: 0 auto;}
.ls_t,.ls_note{text-align: center;}
.ls_t{padding-top: 82px;color: #000033; font-size: 24px;}
.ls_note{font-size: 20px;color: #999;height: 20px;line-height: 20px;margin-top: 30px;}
.ls_ul{overflow: hidden;margin-top: 60px;}
.ls_li{float: left;}
.ls_p{margin: 15px;}
.chose{background-color: #f5f5f5;}
.chose_t{color: #be0000;font-size: 26px;padding-top: 100px;margin-bottom: 40px;}
.chose_note{width: 620px;height: 105px;font-size: 16px;line-height: 30px;letter-spacing: 0;color: #333;margin-bottom: 60px;}
.chose_num{background: url(../../assets/image/jiameng/check.png) left 50% no-repeat; background-size: 28px 20px;height: 25px; color: #333;line-height: 25px;padding-left: 50px;font-size: 16px;margin-bottom: 20px;}
.chose_pic{position: absolute;top: 100px;right: 0;}
.chose_ul{overflow:hidden; padding-bottom: 100px;}
.chose_li{float: left;}
.chose_a{display: block;}
.li_t,.li_note{height: 20px;line-height: 20px;margin-top: 10px}
.li_t{color: #333;font-size: 18px;}
.li_note{color: #999;font-size: 16px;}
.ml5{margin-left: 20px;}
.m5{margin: 0 10px}
.mr5{margin-right: 20px}
.hz{margin-bottom: 50px;margin-top: 80px;}
.toge{width: 100%;background: #f5f5f5;padding: 60px 80px;}
.toge_q{ color: #333;height: 30px;line-height: 30px;overflow:hidden;;font-weight: bold;font-size: 16px;margin-top: 20px}
.q_q{display: block;float: left;width: 24px;height: 24px; color: #fff;background-color: #333;border-radius: 50%;text-align: center;line-height: 24px;margin-right: 20px;margin-top: 2px;}
.qa{font-weight: normal;margin-bottom: 70px;font-size: 16px;}
.qaa{background-color: #cd0000}
.aa{margin-bottom: 0}
.bot{background-color: #2e343d;padding: 40px;overflow:hidden;}
.bot_fl{float: left;width: 360px}
.bot_t,.bot_note{padding-left: 152px;}
.bot_t{color: #fff;font-size: 20px;margin-top: 10px}
.bot_note{ color: #9a9a9a;font-size: 14px;margin-top: 20px;height: 20px;line-height: 20px;}
.code{margin-top: 10px;text-align: center;}
.code_sp{display: block;color: #9a9a9a;font-size: 14px;margin-top: 10px;height: 20px;line-height: 20px;}
.bott{background-color: #1a1d25;height: 80px;line-height: 80px; color: #666;font-size: 12px;text-align: center;}
/*fix*/
.fix_box{background: url(../../assets/image/jiameng/service.png) left top no-repeat; background-size: 214px 457px;width: 214px;height: 457px;position: fixed;left: 95px;top: 30%; display: black;z-index: 99}
.wd80{left: 0;}
.fix{margin-top: 136px;text-align: center;}
.fix_t,.fix_tel,.fix_zx{font-size: 14px;}
.fix_t{color: #666;}
.fix_tel{color: #000;font-weight: bold;margin-top: 14px;font-size: 18px;}
.fix_zx{color: #666;margin-top: 32px;}
.fix_qq{ color: #fff;border-radius: 5px;margin:  0 auto;margin-top: 18px;display: block;width: 86px;height: 20px;line-height: 20px;background: #cd0000 url(../../assets/image/jiameng/q_q.png) 5px 50% no-repeat ; background-size: 16px 16px;padding-left: 10px} 
.fix_co{ color: #666;margin-top: 15px;margin-bottom: 10px}
.qrjp{margin: 0 auto;margin-bottom: 20px;}
.gfix{-webkit-animation:scaleDown 0.5s ease both;-moz-animation:scaleDown 0.5s ease both;animation:scaleDown 0.5s ease both;
display:block;}
.wp{display: none;}
#footer{display: none;}
#erma{display: none;}
.new_up{position: fixed;top: 0;left: 0;bottom: 0;right: 0;background:rgba(0,0,0,0.6);z-index: 10;display: none;}
.new{position: fixed;top: 20px;left: 50%;width: 1128px;margin-left: -564px;z-index: 11;}
.new_clo{background: url(../../assets/image/jiameng/clo.png) 50% 50% no-repeat; background-size: contain; display: block;width: 50px;  height:50px; position: absolute; top: -20px; right:-20px;}
.neng{position: fixed;right: 10px;bottom: 10px;z-index: 99;}
</style>


// WEBPACK FOOTER //
// src/components/jiameng/Index.vue